export const INFLUENCER_IMAGE = '/assets/Influencer/InfluencerCongratulation.png';
